import { render } from "./apply2_1.vue?vue&type=template&id=775aaeb6&scoped=true"
import script from "./apply2_1.vue?vue&type=script&lang=js"
export * from "./apply2_1.vue?vue&type=script&lang=js"

import "./apply2_1.vue?vue&type=style&index=0&id=775aaeb6&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775aaeb6"]])

export default __exports__